import ERROR_INFO from "./icons/errorInfo.svg";
import BITCOIN_YELLOW from "./tokens/btcYellow.svg";
import ETHER_VIOLET from "./tokens/ethViolet.svg";
import TETHER_GREEN from "./tokens/tetherGreen.svg";
import INR_TRANSPARENT from "./tokens/inrTransparent.svg";
import SWITCH_FIELDS from "./icons/switchFields.svg";
import ETHEREUM_CHAIN from "./tokens/ethChain.svg";
import POLYGON_WHITE from "./tokens/polygonWhite.svg";
import INFO from "./icons/info.svg";
import EYE from "./icons/Eye.svg";
import EyeOpen from "./icons/EyeOpen.svg";
import ActivityNav from "./navbar/navbarActivity.svg";
import Close_Btn from "./profilePage/Close_Button.svg";
import Close_Btn_Black from "./icons/Close_buttonDark.svg";
import Copy_Dark from "./icons/CopyDark.svg";
import DownloadPdf from "./icons/DownloadPdf.svg";
import Sell_Txn from "./icons/sellingRed.svg";
import Buy_Txn from "./icons/buyRoundGreentxn.svg";
import TWITTER from "./icons/twitterCircled.svg";
import TELEGRAM from "./icons/telegramCircled.svg";
import P2PX_LOGO from "./navbar/navbarLogo.png";
import MAIN_P2PME from "./icons/mainp2pme.png";
import STAKE from "./icons/stake.svg";
import STATS from "./icons/stats.svg";
import WALLET_BACKUP from "./icons/walletBackup.svg";
import UPLOAD_TRANSACTIONS from "./icons/UploadTransactions.svg";
import DISPUTES from "./icons/Disputes.svg";
import HAMBURGER from "./icons/hamburger.svg";
import ARROW_LEFT from "./icons/ArrowLeft.svg";
import UPLOAD_TRANSACTIONS_IMAGE from "./images/UploadTransactions@2x.png";
import PASTE from "./icons/Paste.svg";
import PASTE_BLACK from "./icons/PASTE_BLACK.svg";
import GOKU from "./icons/goku.svg";
import ArchiveIcon from "./icons/archive.svg";
import EDIT from "./icons/edit-05.svg";
import CHECK from "./icons/check.svg";
import REJECT from "./icons/reject.svg";
import USDC_BLUE from "./icons/usdcBlue.svg";
import USDC_LIGHT from "./icons/usdcLight.svg";
import WALLET from "./icons/wallet_2.svg";
import CANARA_BANK from "./icons/canara.png";
import SBI_BANK from "./icons/sbi.svg";

const APP_ASSETS = {
  ICONS: {
    INFO,
    ERROR_INFO,
    SWITCH_FIELDS,
    EyeOpen,
    EYE,
    Close_Btn,
    ActivityNav,
    Close_Btn_Black,
    Copy_Dark,
    DownloadPdf,
    Buy_Txn,
    Sell_Txn,
    TWITTER,
    TELEGRAM,
    P2PX_LOGO,
    STAKE,
    STATS,
    WALLET_BACKUP,
    UPLOAD_TRANSACTIONS,
    DISPUTES,
    HAMBURGER,
    ARROW_LEFT,
    PASTE,
    PASTE_BLACK,
    ArchiveIcon,
    EDIT,
    CHECK,
    REJECT,
    WALLET,
    MAIN_P2PME,
    CANARA_BANK,
    SBI_BANK,
  },
  TOKENS: {
    BITCOIN_YELLOW,
    ETHER_VIOLET,
    TETHER_GREEN,
    INR_TRANSPARENT,
    ETHEREUM_CHAIN,
    POLYGON_WHITE,
    USDC_LIGHT,
    USDC_BLUE,
  },
  IMAGES: {
    UPLOAD_TRANSACTIONS_IMAGE,
    GOKU,
  },
};

export default APP_ASSETS;
